import CourseController from "../../../../../components/diagrams/course.controller";

class AvoidingDeductiveArgumentsController extends CourseController {

  constructor(helperService, $sce, courseService, $scope) {
    "ngInject";
    super(courseService, helperService, $sce, $scope);
    Object.assign(this, { helperService, $sce, courseService });
    this.videoUrl = this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/322764375');
    // this.helperService.initIntercom();
    this.isUnit = true
    this.introCounted = true
  }

  onSectionFinish() {
    if (this.courseData.is_completed) {
      return
    }
    const params = {
      statisticableId: this.courseData.intro_id,
      statisticableType: 'UnitIntro',
      seconds_spent: Math.floor((Date.now() - this.unitStart) / 1000),
      completed: true,
      attempts: 0,
      hintsUsed: 0,
      rightAnswers: 0
    }
    this.courseService.sendUserStatistic(params)
    this.courseData.is_completed = true
  }

}

export default AvoidingDeductiveArgumentsController;



// WEBPACK FOOTER //
// ./client/app/modules/courses/3/3c/avoidingDeductiveArguments/avoidingDeductiveArguments.controller.js